import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { AttachmentStatus, type Attachment } from '../../interfaces';
import { LoaderTheme } from '../../loader/enums';
import { NotificationTheme } from '../../notifications/enums';

@Component({
  selector: 'fcom-attachment-list',
  templateUrl: './attachment-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AttachmentListComponent {
  readonly AttachmentStatus = AttachmentStatus;
  readonly LoaderTheme = LoaderTheme;
  readonly NotificationTheme = NotificationTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  attachments = input.required<Attachment[]>();
  fileDeleted = output<Attachment>();

  deleteAttachment(attachment: Attachment): void {
    this.fileDeleted.emit(attachment);
  }
}
